
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  XinzangwuyouList,
  PostLaiyuans,
  DeleteXinzangwuyou,
  GetXinzangwuyouDetail,
} from "@/request/doctor";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../../main/components/nav-left/nav-left.vue";
import TimeRange from "@/components/time-range/time-range.vue";
import Read from "../../patient/views/dangan-detail/components/yidongshebei/components/xinzangwuyou/read.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    TimeRange,
    Read,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  private laiyuans: any = [];
  private fengxian: any = ["低危", "中危", "高危", "极高危"];
  private pinggushijian: any = [
    "近7天",
    "近1个月",
    "近3个月",
    "近半年",
    "近1年",
    "自定义",
  ];
  private ifShowRead: any = false;
  private detail: any = {};
  private get localFilter() {
    if (!localStorage.getItem("accountFilter")) {
      return {};
    } else {
      return JSON.parse(localStorage.getItem("xinzangwuyouFilter") || "");
    }
  }
  private set localFilter(val) {
    if (!val) {
      return;
    }
    localStorage.setItem("xinzangwuyouFilter", JSON.stringify(val));
  }
  private getLaiyuan() {
    PostLaiyuans(this).then((res: any) => {
      this.laiyuans = res;
    });
  }
  private laiyuanChange() {
    this.search();
  }
  private fengxianChange() {
    this.search();
  }
  private pinggushijianChange(e: any) {
    console.log(this.filters);
    this.filters["评估时间"] = e;
    this.$forceUpdate();
    if (this.filters["评估时间"] !== "自定义") {
      this.search();
    }
  }
  private timeChange(d: any) {
    console.log("timeChange");
    this.filters = JSON.parse(JSON.stringify(d));
    this.search();
  }
  private deleteOne(item: any) {
    this.$confirm("确定删除该问卷记录么？")
      .then(() => {
        const params: any = {
          data: {
            heart_assess_id: item.heart_assess_id,
          },
        };
        DeleteXinzangwuyou(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.getList();
        });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private goRead(item: any) {
    const params: any = {
      heart_assess_id: item.heart_assess_id,
    };
    GetXinzangwuyouDetail(this, params).then((res: any) => {
      this.detail = res;
      this.ifShowRead = true;
    });
  }
  getList() {
    const params: any = {
      来源: this.filters["来源"],
      period: this.filters["评估时间"],
      风险分层: this.filters["风险分层"],
      search: this.filters.search,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
      begin_date: "",
      end_date: "",
    };
    if (this.filters["评估时间"] === "自定义") {
      params.begin_date = this.filters.startTime;
      params.end_date = this.filters.endTime;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    XinzangwuyouList(this, params)
      .then((data: any) => {
        loading.close();
        this.data = data.datas;
        this.filters.total_count = data.total_count;
        this.filters.total_page = data.total_page;
        if (this.data.length === 0) {
          this.ifShowEmpty = true;
        } else {
          this.ifShowEmpty = false;
        }
      })
      .catch(() => {
        loading.close();
      });
  }

  mounted() {
    this.filters["来源"] = "";
    this.filters["评估时间"] = "";
    this.filters["风险分层"] = "";
    if (localStorage.getItem("xinzangwuyouFilter")) {
      this.filter = JSON.parse(
        localStorage.getItem("xinzangwuyouFilter") as any
      );
    }
    this.getLaiyuan();
    this.getList();
  }
}
